import { StockItem } from '../../../shared-utilities/models-old/datastructures';

export type TStockDisableAuditStatus = 'idle' | 'running' | 'ready' | 'error';

/**
 * Result of the stock-manager disable audit for the selected store.
 */
export interface IStockDisableAuditState {
  disabledRuleMismatches: StockItem[];
  errorMessage: string | null;
  lastRunAt: number | null;
  missingDisableTag: StockItem[];
  partialDisableDescriptions: StockItem[];
  rulesConfigured: boolean;
  scannedCount: number;
  status: TStockDisableAuditStatus;
  storeId: string | null;
  truncated: boolean;
}

/**
 * Idle audit state used before the first run and as the signal default.
 */
export const INITIAL_STOCK_DISABLE_AUDIT: IStockDisableAuditState = {
  disabledRuleMismatches: [],
  errorMessage: null,
  lastRunAt: null,
  missingDisableTag: [],
  partialDisableDescriptions: [],
  rulesConfigured: true,
  scannedCount: 0,
  status: 'idle',
  storeId: null,
  truncated: false,
};
